import React, { useState, useEffect } from 'react';
import { PageHeader, GridDefaultShimmer, ColEdit } from 'dw-components';
import { get, ref, getDatabase } from 'firebase/database';
import { firebaseApp } from '../../../API/firebaseApp';
import { useNavigate } from 'react-router-dom';

const News = (props) => {

    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [columns, setColumns] = useState([
        {
            name: 'Зөвлөгөө мэдээллийн нэр',
            fieldName: 'title',
            onRender: (item) => {
                return (
                    <ColEdit onClick={() => onEdit(item.id)}>{item.title}</ColEdit>
                );
            }
        }, {
            name: 'Категори',
            fieldName: 'categoryname'
        }, {
            name: 'Байрлуулсан огноо',
            fieldName: 'created'
        }, {
            name: 'Төлөв',
            fieldName: 'active',
            onRender: (item) => {
                if (item.active) {
                    return (
                        <div>Идэвхтэй</div>
                    );
                } else {
                    return (
                        <div>Идэвхгүй</div>
                    );
                }
            }
        }
    ]);

    const getData = async () => {
        let tData = [];

        await get(ref(getDatabase(firebaseApp), "news")).then(response => {
            let resp = response.toJSON();
            if (resp) {
                Object.keys(resp)?.map(key => {
                    tData.push({ id: key, ...resp[key] });
                });
            }
        });

        tData.sort((a, b) => {
            if (a.created > b.created) {
                return -1;
            }
            if (a.created < b.created) {
                return 1;
            }
            return 0;
        });

        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onEdit = (pId) => {
        navigate("/admin/news/" + pId);
    }

    const onNew = () => {
        navigate("/admin/news/-1");
    }

    const onAfterSave = async () => {
        await getData();
    }

    return (
        <div>
            <PageHeader
                title="Зөвлөгөө, мэдээлэл"
                buttonTitle="Зөвлөгөө, мэдээлэл нэмэх"
                onButtonClick={onNew}
                dataCount={data?.length}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
            />
            <GridDefaultShimmer
                data={data}
                columns={columns}
                loading={loading}
            />
        </div>
    );
}

export default News;